<template>
  <div class="item">
    <div class="content">
      <div class="header">{{ this.findLocation(sli.location) }}</div>
      <div class="meta">{{ new Date(sli.created).toLocaleString('en-GB') }} by {{ ((sli.createdby && sli.createdby.hasOwnProperty('adminname'))?sli.createdby.adminname:sli.createdby) }}</div>
      <div class="content">
        <div class="header">Number of items: {{ sli.regs.length }} 
        <button v-if="!regsVisible" class="ui tertiary button" @click="regsVisible=true">show registrations</button>
        <button v-if="!!regsVisible" class="ui tertiary button" @click="regsVisible=false">hide registrations</button>
        <button class="ui tertiary button" @click="exportCSV(sli)">Export to CSV</button></div>
        <div  v-if="(sli.unrecognised && sli.unrecognised.length>0)">
          <div class="header">Unrecognised plates ({{ sli.unrecognised.length }}):</div>
          <div class="ui fluid stackable cards" style="margin-top:1em">
            <div class="card" v-for="(p, index) in sli.unrecognised" :key="index">
              <div class="image">
                <img :src="this.$host+'/img/unrec/'+p.p+'.jpg'">
                <div class="content">
                  <form class="ui form">
                    <input type="text" class="ui input" placeholder="type plate here" v-model="p.reg">
                  </form>
                </div>
                <div class="extra content">
                  <button class="ui right aligned primary mini button" @click="saveReg(p.p, p.reg)">confirm</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui items" v-if="!!regsVisible">
          <div class="item" v-for="(reg, index) in sli.regs" :key="index">
            <div class="content">
              <div class="header">
                <span class="ui yellow label" style="color:black!important;text-transform:uppercase">{{ reg.reg }}</span>
              </div>
              <div v-if="!reg.vehicle" class="meta">We don&apos;t have this vehicle in our database.</div>
              <div v-if="!!reg.vehicle" class="meta">{{ reg.vehicle.make }} {{ reg.vehicle.model }} {{ reg.vehicle.derivative }}</div>
              <div v-if="!!reg.vehicle" class="meta">Fleet no:{{ reg.vehicle.fleetnumber }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  function exportToCsv(filename, rows) {
    var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
            result = '"' + result + '"';
        if (j > 0)
            finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
    }
  }

  export default {
    props: ['sli'],
    data() {
      return {
        regsVisible:false
      };
    },
    methods: {
      saveReg(id, reg) {
        this.$emit('saveRegEvent', id, reg);
      },
      findLocation(lid) {
        for (var i=0; i<this.$locations.length; i++) {
          if ((this.$locations[i].id+'') === lid+'') {
            return this.$locations[i].companyname;
          }
        }

        return '--';
      },
      exportCSV() {
        var a,b;
        var rows = [];

        for (a=0;a<this.sli.regs.length; a++) {
          b = [
            this.findLocation(this.sli.location),
            this.sli.regs[a].reg,
            ((this.sli.regs[a].vehicle && this.sli.regs[a].vehicle.make)?this.sli.regs[a].vehicle.make:'-vehicle not found-'),
            ((this.sli.regs[a].vehicle && this.sli.regs[a].vehicle.model)?this.sli.regs[a].vehicle.model:''),
            ((this.sli.regs[a].vehicle && this.sli.regs[a].vehicle.derivative)?this.sli.regs[a].vehicle.derivative:'')
          ];
          rows.push(b);
        }

        exportToCsv('stocklist.'+this.sli.location+'.'+Date.now()+'.csv', rows);
      },
    }
  }
</script>
